module.exports = __webpack_public_path__ + "static/mills-722f6245ece08652a9ef9efbbd53b2b2.png";